// This import loads the firebase namespace along with all its type information.
import ContentHouseMediaSnapshot from './content-house-media-snapshot-model'

export async function load_contentHouseMediaSnapshots(): Promise<
  ContentHouseMediaSnapshot[]
> {
  throw 'Not implemented'
}

export async function delete_contentHouseMediaSnapshot(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_contentHouseMediaSnapshot(): Promise<ContentHouseMediaSnapshot> {
  throw 'Not implemented'
}
